// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"bf88ca13","672":"f75e0b13"}[chunkId] + ".chunk.css";
};